import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-trash2-icon lucide-trash-2",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10 11v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 11v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 6h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
	]
});
export default SvgTrash;
